import { ParentNode } from '../types';

const excludedKeys = ['toString'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isParent = (object: any): object is ParentNode => {
  if (typeof object === 'function' || typeof object === 'object') {
    return Object.keys(object).filter((key) => !excludedKeys.includes(key)).length > 0;
  }
  return false;
};
